/**
 * Enum for field types.
 * @readonly
 * @enum {string}
 */
export const FIELD_TYPE = {
    STRING: 'string',
    TEXT: 'text',
    BOOLEAN: 'boolean',
    JSON: 'json',
    SELECT: 'select',
    MULTI_SELECT: 'multi_select'
}
